import type { IconName } from "@similarweb/icons";
import { OpportunityListTypeEnum } from "app/pages/sales-intelligence/sub-modules/opportunities/types";
import type { ListItemDto } from "../../types/dto";

export const getListIconName = ({ listType, crmIntegrationType }: ListItemDto): IconName => {
    switch (listType) {
        case OpportunityListTypeEnum.Crm:
            return crmIntegrationType ?? "snippet-list";

        case OpportunityListTypeEnum.Shared:
        case OpportunityListTypeEnum.RecentlyViewed:
        case OpportunityListTypeEnum.ManuallyCreated:
        default:
            return "snippet-list";
    }
};
